module.exports = __webpack_public_path__ + "static/media/2016_conf_Make_it_Clear.87c15dd2.png";